<template>
<panel>
  <p slot="header">
    Administratorzy
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="add_circle" color="primary" @click="$router.push({name: 'admin.users.create'})" >Dodaj administratora</ui-button>
  </p>
  <users-list></users-list>
</panel>
</template>
<script>
import Users from '../../services/Users'
import EventEmitter from '../../services/EventEmitter'

export default {
  data () {
    return {
      modal: {
        show: false,
        title: 'Dodaj administratora',
        baseCreateTitle: 'Dodaj administratora',
        baseUpdateTitle: 'Edytuj administratora'
      },
      item: Users.getBaseItem()
    }
  },
  methods: {
    onUsersChange (e) {
      this.modal.show = false
      EventEmitter.$emit('users.reload', e)
    }
  },
  mounted () {
  }
}
</script>











// WEBPACK FOOTER //
// Dashboard.vue?31c9ae72